import { map, OperatorFunction } from 'rxjs';
import { ResponseObj } from '../models/response.model';
import { ApprovalApiError } from '../errors/approval-api-error';

export function unwrapResponse<T>(): OperatorFunction<ResponseObj<T>, T> {
  return map((response) => {
    if (response.status === 'FAILED') {
      throw new ApprovalApiError(response.message ?? 'Request failed');
    }
    return response.object;
  });
}
